import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
export default function WorkCard() {
	useEffect(() => {
		AOS.init();
	  }, [])
  return (
    <div>
      <section class="p-6 bg-white mt-12">
	<div class="lg:w-4/5 md:w-full mx-auto">
		<h2 class="text-4xl font-bold text-center">Get started in three simple steps.</h2>
		<div class="grid gap-10 pl-28 my-14 sm:grid-cols-3 -ml-10 lg:-ml-0">
			<div class="flex flex-col p-8 space-y-4 rounded-md bg-white border-t-2 border-r-2  border-gray-200 shadow-md w-3/4" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
				<div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-xl font-bold rounded-full bg-[#4c9bdc] dark:text-gray-900">1</div>
				<p class="text-2xl font-semibold flex justify-start">
					Create an account
				</p>
			</div>
			<div class="flex flex-col p-8 space-y-4 rounded-md bg-white border-t-2 border-r-2  border-gray-200 shadow-md w-3/4" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
				<div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-xl font-bold rounded-full bg-[#4c9bdc] dark:text-gray-900">2</div>
				<p class="text-2xl font-semibold justify-start">
					Verify your account
				</p>
			</div>
			<div class="flex flex-col p-8 space-y-4 rounded-md bg-white border-t-2 border-r-2  border-gray-200 shadow-md w-3/4" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
				<div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-xl font-bold rounded-full bg-[#4c9bdc] dark:text-gray-900">3</div>
				<p class="text-2xl font-semibold justify-start">
        			Send your money!
				</p>
			</div>
		</div>
	</div>
</section>
    </div>
  );
}
